import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@jauntin/react-ui';

const ButtonEdit = ({ edit, show }) =>
  show && (
    <div className="col-auto my-auto">
      <Button className="btn-link btn--edit" text="Edit" onClick={edit} />
    </div>
  );

ButtonEdit.propTypes = {
  edit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default ButtonEdit;
